import clsx from "clsx";
import i18next from "i18next";
import useStyles from 'style/js-style/components/thirdparties/securityRating/SecurityRatingStyle';

const SecurityRatingMaturityLabel = ({ maturity, className }) => {
  const { classes } = useStyles();
  return (
    <div
      className={clsx(
        classes.globalMaturityLabel,
        maturity?.toLowerCase(),
        className || ""
      )}
    >
      {i18next.t(`securityRating.maturity.${maturity?.toLowerCase()}`)}
    </div>
  )
}
export default SecurityRatingMaturityLabel;